/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

import {useSelector} from 'react-redux';
import {permissionSelectedSelector} from '@ion/applications/src/store/selectors/login';
import {Entity, Link} from '@ion/core/src/types/entities';
import {Operation} from '@ion/core/src/types/general';

// [ION-APP TODO]: This module has been deprecated and clients will need
// to be updated to use the `Features API` exclusively, specifically, the
// `Features.hasFeature` method.

/**
 * @deprecated - iOn Monorepo Applications are ONLY to determine Access to Features
 * via the Applications Features. References to `Permissions` is **An Anti-Pattern!**
 * and are **NOT TO BE USED!!!**. For additional information and details, please see:
 * https://calampcorp.atlassian.net/browse/IMO-174.
 */
export const hasPermission = (permissions: Link[], permission: string): boolean => {
  const permissionsMap = getPermissionMap(permissions);
  return !!permissionsMap?.[permission];
};

/**
 * @deprecated - iOn Monorepo Applications are ONLY to determine Access to Features
 * via the Applications Features. References to `Permissions` is **An Anti-Pattern!**
 * and are **NOT TO BE USED!!!**. For additional information and details, please see:
 * https://calampcorp.atlassian.net/browse/IMO-174.
 */
export const getPermissionMap = (permissions: Link[]) => {
  const permissionsMap = {};
  permissions?.forEach((permission) => {
    permissionsMap[permission?.title] = true;
  });
  return permissionsMap;
};

/**
 * @deprecated - iOn Monorepo Applications are ONLY to determine Access to Features
 * via the Applications Features. References to `Permissions` is **An Anti-Pattern!**
 * and are **NOT TO BE USED!!!**. For additional information and details, please see:
 * https://calampcorp.atlassian.net/browse/IMO-174.
 */
export const useHasPermission = (entity: Entity | string, op: Operation | string = Operation.Create): boolean => {
  const permissions = useSelector(permissionSelectedSelector);
  const permission  = entity?.toLowerCase().concat('-', op);
  return hasPermission(permissions, permission);
};

export default useHasPermission;
